import { render, staticRenderFns } from "./comp-layout.vue?vue&type=template&id=60b7e09e&scoped=true&lang=pug&"
import script from "./comp-layout.vue?vue&type=script&lang=js&"
export * from "./comp-layout.vue?vue&type=script&lang=js&"
import style0 from "./comp-layout.vue?vue&type=style&index=0&id=60b7e09e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b7e09e",
  null
  
)

export default component.exports